import { type FC, type ReactNode } from 'react'

import ImageLink, { type ImageLinkProps } from '@DS/components/forms/links/imageLink/ImageLink'

type ODSearchExternalLinkProps = {
  href?: ImageLinkProps['href']
  'aria-label': ImageLinkProps['aria-label']
  children: ReactNode
}

const ODSearchExternalLink: FC<ODSearchExternalLinkProps> = ({ href, 'aria-label': ariaLabel, children }) => {
  if (!href) {
    return children
  }

  return (
    <ImageLink href={href} aria-label={ariaLabel} isExternal>
      {children}
    </ImageLink>
  )
}

export default ODSearchExternalLink
